import { isInputHasLocale } from "helpers/forms";
import React from "react";

const InputGroupFieldError = ({ errors, name, index, input, locale = "" }) => {
    if (!isInputHasLocale(locale)) {
        return errors?.[name]?.[index]?.[input?.name] ? (
            <p className="error-hint">
                {errors?.[name]?.[index]?.[input?.name].message}
            </p>
        ) : (
            ""
        );
    }

    return errors?.[name]?.[index]?.[input?.name]?.[locale] ? (
        <p className="error-hint">
            {errors?.[name]?.[index]?.[input?.name]?.[locale].message}
        </p>
    ) : (
        ""
    );
};

export default InputGroupFieldError;
